import Menu from './Menu'

export default function AccountingMenu() {
    return (<Menu items={[
        ['/accounting/payouts', 'faDollar', 'Pagos'],
    ]} />)
}